const anchors = document.querySelectorAll('.page-navigation__link[href^="#"], .button[href^="#"], a[href^="#"]');

anchors.forEach(anchor => {
  anchor.addEventListener("click", event => {
    event.preventDefault();

    let target = document.querySelector(anchor.getAttribute('href'));
    let top = target.offsetTop;
    let header = document.querySelector('.header-wrapper');
    let offsetHeaderHeight = header.offsetHeight;

    window.scrollTo({
      top: top - offsetHeaderHeight,
      behavior: 'smooth'
    });
  });
});